import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import ChartPieIcon from '@atlaskit/icon/core/chart-pie';
import { useSidebar } from '@atlassian/jira-business-app-wrapper';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';
import { SidebarContent } from './sidebar';

export const IssueFieldStatisticsButton = () => {
	const { formatMessage } = useIntl();
	const [, { setSidebarContent, closeSidebar }] = useSidebar();

	const onClick = () => {
		setSidebarContent(<SidebarContent onClose={closeSidebar} />);
	};

	return (
		<IconButton
			appearance="subtle"
			icon={ChartPieIcon}
			label={formatMessage(messages.tooltip)}
			isTooltipDisabled={false}
			onClick={onClick}
		/>
	);
};
